import gql from 'graphql-tag'
import { BaseDealAutoAttributeFragment } from '@/graphql/fragments/public/dealAutoAttribute'

export const mutation = gql`
  ${BaseDealAutoAttributeFragment}
  mutation insertDealAutoAttribute($fields: deal_auto_attribute_insert_input!) {
    record: insert_deal_auto_attribute_one(object: $fields) {
      ...BaseDealAutoAttribute
    }
  }
`

export default mutation
